import type { FC } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, useTheme } from '@mui/material';

import type { ActionItemStatus } from 'src/types/followUp';

import { styles } from '../table.styles';

interface StatusPillProps {
  status: ActionItemStatus;
}

const StatusPill: FC<StatusPillProps> = ({ status }) => {
  const theme = useTheme();
  const { color, backgroundColor } = useMemo(() => {
    switch (status) {
      case 'Open':
        return {
          color: theme.colors.primary[700],
          backgroundColor: theme.colors.primary[50],
        };
      case 'Closed':
        return {
          color: theme.colors.success[800],
          backgroundColor: theme.colors.tertiary[50],
        };
      case 'Overdue':
        return {
          color: theme.colors.error[50],
          backgroundColor: theme.colors.error[500],
        };
      case 'In Progress':
      default:
        return {
          color: theme.colors.secondary[900],
          backgroundColor: theme.colors.secondary[50],
        };
    }
  }, [status]);
  const { t } = useTranslation('followUp');
  return (
    <Box
      sx={{
        ...styles.statusPill,
        backgroundColor,
        color,
      }}
    >
      {t(`status.${status}`)}
    </Box>
  );
};

export default StatusPill;
